import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';
import { Validator as SellValidator } from 'containers/Sell/Validator';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { getFirstError } from 'helpers/forms';
import { isEmpty } from 'helpers/verify';
import { waitlistRequest } from 'redux/saga/entities/bound';
import { LeadGenForm } from './LeadGenForm';
import { joinWaitlist, watchLeadGenFormSagas } from './LeadGenForm.saga';
var formConfig = {
  destroyOnUnmount: false,
  form: 'leadgen',
  validate: SellValidator
};
var getError = getFirstError(formConfig.form);
export var mapStateToProps = function mapStateToProps(state) {
  return {
    formError: getError(state) || waitlistRequest.error(state),
    wasCaptured: !isEmpty(waitlistRequest.data(state))
  };
};
export var mapDispatchToProps = {
  onWaitlistRequest: joinWaitlist
};
export var LeadGenFormContainer = decorateWith(injectIntl, reduxForm(formConfig), withName('LeadGenForm'), withSagas({
  watch: watchLeadGenFormSagas
}), connect(mapStateToProps, mapDispatchToProps))(LeadGenForm);